import React from "react"
import a23logo from '../assets/a23_avatar_logo.png'
import close from '../assets/close.png'
import { connect } from "react-redux";
import { toggleModalAction } from '../redux/actions/userAction'
import {REDEEM_HISTORY} from "../Strings"

class RGCancleAlert extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            Loading: false,
            btntxt: "Verify",
          };  
    }

    handleCloseButton=()=>{
        this.props.toggleModalAction(false)
      }
 render(){
     return(
         <div>
               <div id="nee yenka" class="relative absolute--fill flex justify-center items-center center left-1 right-1 white w6 ">
               <img class="absolute black nt4  left-0 top-0 right-0 h3 w3 center white flex justify-center items-center  pointer z-9999 " src={a23logo} alt="not available" ></img>
               <div className="center br2 ba pa1 b--black-10 flex flex-column" style={{backgroundColor:"#fffdea",color:"#032146",bordercolor:"#EABF6979",paddingTop: "1rem" }}   
               >          
                <div className="db pt2 f6 mt2 center">
                
            
                <div className="w-100 db f6 tc mt2 ">
                    <h4 className=" mt0 mb2 fw5 ph5 f5 text-bold">{REDEEM_HISTORY.REDEEM_HISTORY_RG_ALERT}</h4>
                    <p className=" f5 ph2  mb4  text-medium">{REDEEM_HISTORY.REDEEM_HISTORY_RG_ALERT_TEXT}</p>
                </div>

               
                <div className="center tc">
                <button type="submit" className=" tc center pointer bw0 ba br2 w-40 dib pv2 bg-green white text-medium" onClick={()=>this.props.toggleModalAction(false)}>{REDEEM_HISTORY.REDEEM_HISTORY_RG_ALERT_BTN}
                
                    </button>
                    <div className="h1"></div>
                </div>
         </div>
         </div>
         </div>
         </div>
        
     )
 }
}
const mapStateToProps = state => ({
    modalState: state.userState
  });
  
  export default connect(
    mapStateToProps,
    { toggleModalAction }
  )(RGCancleAlert);